var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('highcharts',{staticStyle:{"height":"300px !important"},attrs:{"options":_vm.chartOptions}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }